const stateRequest = {
    nameState: 'State request services',
    requests_count: 0,

}

export default stateRequest;